<template>
    <div class="page-admin">
        <div class="container">

            <form @submit.prevent="onSubmit">

                <div class="tabs is-boxed">
                    <ul>
                        <li :class="{'is-active':activeTab=='defaultCategories'}"><a @click="tab('defaultCategories')">Categorias</a></li>
                        <li :class="{'is-active':activeTab=='suggestedLinks'}"><a @click="tab('suggestedLinks')">Links sugeridos</a></li>
                    </ul>
                </div>

                <div v-show="activeTab=='defaultCategories'">
                    <div v-for="(category,index) in config.defaultCategories">
                        <div class="columns is-4">
                            <div class="column">
                                <div class="control">
                                    <input class="input" type="text" v-model="category.name" placeholder="Nome" required>
                                </div>
                                <div class="control">
                                    <label><input type="checkbox" v-model="category.isChecked"> Selecionado por padrão</label>
                                </div>
                                <div class="control">
                                    <label><input type="checkbox" v-model="category.isSponsored"> Patrocinado</label>
                                </div>
                                <div class="control" v-if="category.isSponsored">
                                    <textarea class="input" v-model="category.sponsorInfo" placeholder="Texto tooltip"></textarea>
                                </div>
                                <div class="control">
                                    <button v-if="config.defaultCategories.length>0" class="button" @click.prevent="removeCategory(index)">&times;</button>
                                    <button v-if="index>0" class="button" @click.prevent="moveUpCategory(index)">↑</button>
                                    <button v-if="index<config.defaultCategories.length-1" class="button" @click.prevent="moveDownCategory(index)">↓</button>
                                </div>
                            </div>
                            <div class="column is-8">
                                <div class="field has-addons" v-for="(link,index) in category.links">
                                    <input class="input" type="text" v-model="link.name" placeholder="Nome" required>
                                    <input class="input" type="url" v-model="link.url" placeholder="URL" required>
                                    <button class="button" @click.prevent="removeLink(category,index)">&times;</button>

                                </div>
                                <button class="button" @click.prevent="addLink(category)">Adicionar link</button>
                            </div>
                        </div>



                    </div>
                    <div class="field">
                        <button class="button" @click.prevent="addCategory">Adicionar categoria</button>
                    </div>
                </div>

                <div v-show="activeTab=='suggestedLinks'">

                    <div class="field has-addons" v-for="(link,index) in config.suggestedLinks">
                        <input class="input" type="text" v-model="link.name" placeholder="Nome" required>
                        <input class="input" type="url" v-model="link.url" placeholder="URL" required>
                        <button class="button" @click.prevent="removeSuggestedLink(index)">&times;</button>

                    </div>
                    <button class="button" @click.prevent="addSuggestedLink">Adicionar link</button>


                </div>



                <div class="field">
                    <button class="button is-primary" type="submit">Salvar</button>
                </div>
            </form>




        </div>
    </div>


</template>
<style>
.page-admin { padding:40px 0; }
</style>
<script>

    /* eslint-disable no-console */
//import firebase from 'firebase';
import firebase from '@/firebase'
export default {
    data(){
        return {
            db: null,
            activeTab:'defaultCategories',
            config:{
                defaultCategories:[],
                suggestedLinks:[]
            },

        }
    },
    computed: {
        userId() {
            return this.$store.getters.userId;
        },

    },
    methods: {
        tab(tab){
            this.activeTab = tab;
        },
        moveUpCategory(index){
            var cat = this.config.defaultCategories.splice(index,1);
            this.config.defaultCategories.splice(index-1,0,cat[0]);
        },
        moveDownCategory(index){
            var cat = this.config.defaultCategories.splice(index,1);
            this.config.defaultCategories.splice(index+1,0,cat[0]);

        },
        removeCategory(index){
            if(!confirm('Apagar?')) return;
            this.config.defaultCategories.splice(index,1);
        },
        removeLink(category,index){
            if(!confirm('Apagar?')) return;
            category.links.splice(index,1);
        },
        addSuggestedLink(){
            this.config.suggestedLinks.push({});
        },
        removeSuggestedLink(index){
            if(!confirm('Apagar?')) return;
            this.config.suggestedLinks.splice(index,1);
        },
        addLink(category){
            category.links.push({});
        },
        addCategory(){
            this.config.defaultCategories.push({links:[{}]});
        },
        onSubmit(){
            this.$store.dispatch('saveConfig',{config:this.config});
        }
    },
    activated(){
    },
    created(){
        if(this.$store.state.user.email!='fernando.mmro@gmail.com' && this.$store.state.user.email!='giannoulakis@gmail.com'){
            this.$router.push({name:'home'});
            return;
        }
        const db = firebase.firestore();

        if(this.$store.state.config.isLoaded){
            this.config = this.$store.state.config;
        } else {
            this.$store.dispatch('startLoading');
            db.collection('admin').doc('config').get().then(doc => {
                var config = doc.data();
                config.isLoaded = true;
                this.config.defaultCategories = config.defaultCategories;
                this.config.suggestedLinks = config.suggestedLinks || [];
                this.$store.dispatch('stopLoading');
            })
        }
    },
}
</script>
